export const navigationElements = [
    "vdlgeert",
    "services",
    "toolbox",
    "experiences",
    "contact"
]
